import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import "../Slide/SlideDeleteValidator.scss";
import "../../css/Popup.scss";
import { keycloak } from "../../services/keycloak";

const LogoutModal = ({register, registerLogoutPopup }) => {
    const [logoutPopup, setLogoutPopup] = useState(false)
    const [logoutTimer, setLogoutTimer] = useState(120);
    const timerInterval = useRef(null);
    const popupTimeout = useRef(null);
    const poupInterval = useRef(null)
    const popupShownRef = useRef(false);

    const resetLogoutPopup = async() => {
        setLogoutPopup(false)
        setLogoutTimer(0)
        popupShownRef.current = false
        if (popupTimeout.current) clearTimeout(popupTimeout.current)
        if (timerInterval.current) clearInterval(timerInterval.current);
        window.removeEventListener("storage", handleStorage)
    }

    const scheduleLogoutTimer = () => {
        if (popupTimeout.current) clearTimeout(popupTimeout.current);

        const popupTime = getTimeLeft();
        
        const triggerTime = popupTime - 20;
        
        if (triggerTime > 0) {
            popupTimeout.current = setTimeout(() => {
                startExpiryWatcher();
            }, triggerTime * 1000);
        }
    };

    const startExpiryWatcher = () => {
        if (poupInterval.current) clearInterval(poupInterval.current);
        
        poupInterval.current = setInterval(() => {
            const popupTime = getTimeLeft();
            if (popupTime <= 0 && !popupShownRef.current) {
                popupShownRef.current = true;

                clearInterval(poupInterval.current);

                setLogoutPopup(true);
                run120SecTimer();
            }
        }, 1000);
    };

    const getTimeLeft = () => {
        const exp = keycloak.tokenParsed?.exp;
        const now = Math.floor(Date.now() / 1000);
        const timeLeft = exp - now;
        return timeLeft - 120 + keycloak.timeSkew;
    };

    const handleStorage = async(event) => {
        console.log("STORAGE EVENT FIRED");
        console.log("key:", event.key);
        console.log("newValue:", event.newValue);
        if (event.key === "kc-sync" && event.newValue) {
            setLogoutPopup(false);
            await keycloak.updateToken(-1)
            localStorage.removeItem("kc-sync");
        }
    };

    useEffect(()=> {
        register(() => scheduleLogoutTimer)
        registerLogoutPopup(()=> resetLogoutPopup)
        window.addEventListener("storage", handleStorage);
        
        return () => {
            if (popupTimeout.current) clearTimeout(popupTimeout.current)
            if (timerInterval.current) clearInterval(timerInterval.current);
            window.removeEventListener("storage", handleStorage)
        };
    }, [])

    const handleLogout = async () => {
        setLogoutPopup(false)
        popupShownRef.current = false
        if (popupTimeout.current) clearTimeout(popupTimeout.current)
        if (timerInterval.current) clearInterval(timerInterval.current);
        try {
            await keycloak.logout({
                redirectUri: window.location.origin
            });
        } catch (e) {
            console.error("Logout failed", e);
        }
    };

    const handleContinue = async () => {
        setLogoutPopup(false)
        popupShownRef.current = false
        if (popupTimeout.current) clearTimeout(popupTimeout.current)
        if (timerInterval.current) clearInterval(timerInterval.current);
        try {
            await keycloak.updateToken(-1);
            localStorage.setItem("kc-sync", Date.now().toString())
            setLogoutTimer(120);
        } catch (e) {
            console.error("Token refresh failed", e);
            handleLogout();
        }
    };

    const run120SecTimer = () => {
        timerInterval.current = setInterval(() => {
            setLogoutTimer(prev => prev - 1);
        }, 1000);
    };

    useEffect(() => {
        if (logoutTimer <= 0) {
            setLogoutPopup(false)
            // handleLogout()
        }
    }, [logoutTimer]);

    return (
        <div className="deletePromptParent">
            <Dialog
                open={logoutPopup}
                // onClose={handleLogout}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="deletePrompt confirmation"
                sx={{
                    backdropFilter: "blur(2.4px)",
                }}
            >
                <DialogContent style={{ overflowY: "initial", width: "380px", height: "160px" }}>
                    <DialogContentText
                        id="alert-dialog-description"
                        className="discription"
                    >
                        <div className="popup-head">SESSION TIME OUT</div>
                        <div className="popup-separator"></div>
                        <div className="popup-message"><span style={{ color: "#C50F3C" }}>Your session is about to expire in {logoutTimer} sec.</span> Would you like to continue?</div>
                    </DialogContentText>
                </DialogContent>
                <div className="popupFooter">
                    {/* <div className="popupFooterSeparator"></div> */}
                    <Button
                        className="btn popupFooterGrayedButton"
                        type="button"
                        onClick={handleLogout}
                    >
                        LOG OUT
                    </Button>
                    <Button
                        className="btn popupFooterActiveButton"
                        type="button"
                        onClick={handleContinue}
                    >
                        CONTINUE SESSION
                    </Button>
                </div>
            </Dialog>
        </div>
    );
};

export default LogoutModal;